<div class="my-5" [ngSwitch]="value">
  <!-- case 1 -->
  <div class="container-fluid v4-bg-img" *ngSwitchCase="1">
    <div
      class="d-flex justify-content-center align-items-center wrapper loader-mtop-bottom"
    >
      <!-- <svg class="hourglass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 206" preserveAspectRatio="none">
          <path class="middle" d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"/>
          <path class="outer" d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"/>
      </svg> -->
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
      <div class="loading-txt">
        &nbsp;&nbsp;{{ "download" | translator }}...
      </div>
    </div>
    <!-- <div class="row mx-5">
      <div class="col-md-8 col-12 p-0">
        <div class="card">
          <p-table [value]="tableList" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>.....</th>
                <th>.....</th>
                <th>.....</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="col-md-4 col-12 p-0">
        <div class="container">
          <p-skeleton width="100%" height="440px"></p-skeleton>
        </div>
      </div>
    </div> -->
  </div>
  <!-- case 1 END -->

  <!-- case 2 -->
  <div class="container-fluid v4-bg-img" *ngSwitchCase="2">
    <div
      class="d-flex justify-content-center align-items-center wrapper loader-mtop-bottom"
    >
      <!-- <svg class="hourglass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 206" preserveAspectRatio="none">
        <path class="middle" d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"/>
        <path class="outer" d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"/>
    </svg> -->
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
      <div class="loading-txt">
        &nbsp;&nbsp;{{ "download" | translator }}...
      </div>
    </div>
    <!-- <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <div class="card">
          <p-table [value]="tableList" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>.....</th>
                <th>.....</th>
                <th>.....</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div> -->
  </div>
  <!-- case 2 END -->

  <!-- case 3 -->
  <div class="container-fluid v4-bg-img" *ngSwitchCase="3">
    <div
      class="d-flex justify-content-center align-items-center wrapper loader-mtop-bottom"
    >
      <!-- <svg class="hourglass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 206" preserveAspectRatio="none">
          <path class="middle" d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"/>
          <path class="outer" d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"/>
      </svg> -->
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
      <div class="loading-txt">
        &nbsp;&nbsp;{{ "download" | translator }}...
      </div>
    </div>
    <!-- <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <div class="card">
          <p-table [value]="tableList" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>.....</th>
                <th>.....</th>
                <th>.....</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <br> <br>
      <hr> <br> <br>
      <div class="col-md-12 col-12 p-0">
        <div class="container">
          <p-skeleton width="100%" height="440px"></p-skeleton>
        </div>
      </div>
      <br> <br>
    </div> -->
  </div>
  <!-- case 3 END -->

  <!-- case 4 - Knowledge Library skeleton -->
  <div *ngSwitchCase="4" dir="rtl">
    <div class="container max-width-1700 my-4 kl-skeleton">
      <!-- Toolbar row: dropdowns, date, reset, view toggle -->
      <div class="row mb-3 align-items-center">
        <div class="col-lg-2 col-md-4 col-6 my-1">
          <p-skeleton width="100%" height="2.8rem" borderRadius="6px"></p-skeleton>
        </div>
        <div class="col-lg-2 col-md-4 col-6 my-1">
          <p-skeleton width="100%" height="2.8rem" borderRadius="6px"></p-skeleton>
        </div>
        <div class="col-lg-2 col-md-4 col-6 my-1">
          <p-skeleton width="100%" height="2.8rem" borderRadius="6px"></p-skeleton>
        </div>
        <div class="col-lg-2 col-md-4 col-6 my-1 d-flex gap-2">
          <div class="flex-grow-1 min-w-0">
            <p-skeleton width="100%" height="2.8rem" borderRadius="6px"></p-skeleton>
          </div>
          <p-skeleton width="2.8rem" height="2.8rem" borderRadius="6px" styleClass="flex-shrink-0"></p-skeleton>
        </div>
      </div>

      <!-- Categories label -->
      <div class="d-flex justify-content-start mb-2">
        <p-skeleton width="8rem" height="1.4rem" borderRadius="4px"></p-skeleton>
      </div>

      <!-- Main content row -->
      <div class="row">
        <!-- Category sidebar (col-3, right side in RTL) -->
        <div class="col-lg-3 col-md-4 col-12 mb-3">
          <!-- Category item 1 (active style) -->
          <div class="kl-category-skeleton active mb-2">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-2">
                <p-skeleton width="1.2rem" height="1.2rem" borderRadius="4px"></p-skeleton>
                <p-skeleton width="4rem" height="1rem" borderRadius="4px"></p-skeleton>
              </div>
              <p-skeleton width="2rem" height="1.6rem" borderRadius="12px"></p-skeleton>
            </div>
          </div>
          <!-- Category item 2 -->
          <div class="kl-category-skeleton mb-2">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-2">
                <p-skeleton width="1.2rem" height="1.2rem" borderRadius="4px"></p-skeleton>
                <p-skeleton width="6rem" height="1rem" borderRadius="4px"></p-skeleton>
              </div>
              <p-skeleton width="2rem" height="1.6rem" borderRadius="12px"></p-skeleton>
            </div>
          </div>
          <!-- Category item 3 -->
          <div class="kl-category-skeleton mb-2">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-2">
                <p-skeleton width="1.2rem" height="1.2rem" borderRadius="4px"></p-skeleton>
                <p-skeleton width="10rem" height="1rem" borderRadius="4px"></p-skeleton>
              </div>
              <p-skeleton width="2rem" height="1.6rem" borderRadius="12px"></p-skeleton>
            </div>
          </div>
          <!-- Category item 4 -->
          <div class="kl-category-skeleton mb-2">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-2">
                <p-skeleton width="1.2rem" height="1.2rem" borderRadius="4px"></p-skeleton>
                <p-skeleton width="7rem" height="1rem" borderRadius="4px"></p-skeleton>
              </div>
              <p-skeleton width="2rem" height="1.6rem" borderRadius="12px"></p-skeleton>
            </div>
          </div>
        </div>

        <!-- Cards grid (col-9, left side in RTL) -->
        <div class="col-lg-9 col-md-8 col-12">
          <div class="row">
            <!-- Card skeleton repeated 9 times (3x3 grid) -->
            <div class="col-lg-4 col-md-6 col-12 mb-3" *ngFor="let item of [1,2,3,4,5,6,7,8,9]">
              <div class="kl-card-skeleton">
                <!-- Card header: date badge + avatar -->
                <div class="d-flex justify-content-between align-items-start p-3">
                  <p-skeleton width="5.5rem" height="1.6rem" borderRadius="16px"></p-skeleton>
                  <p-skeleton shape="circle" size="2.8rem"></p-skeleton>
                </div>
                <!-- Category text -->
                <div class="px-3 mb-1">
                  <p-skeleton width="5rem" height="0.8rem" borderRadius="4px"></p-skeleton>
                </div>
                <!-- Title -->
                <div class="px-3 mb-2">
                  <p-skeleton width="85%" height="1.1rem" borderRadius="4px"></p-skeleton>
                </div>
                <!-- Separator -->
                <div class="px-3">
                  <p-skeleton width="100%" height="1px"></p-skeleton>
                </div>
                <!-- Description / footer -->
                <div class="d-flex justify-content-between align-items-center p-3">
                  <p-skeleton width="60%" height="0.9rem" borderRadius="4px"></p-skeleton>
                  <p-skeleton width="1.2rem" height="0.5rem" borderRadius="4px"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- case 4 END -->

  <!-- case 5 for data managment page  -->
  <div class="container-fluid desktop-skeleton" *ngSwitchCase="5">
    <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <div class="d-flex justify-content-between">
          <p-skeleton width="10rem" height="2rem"></p-skeleton>
          <p-skeleton
            width="30rem"
            height="2rem"
            styleClass="mx-2"
          ></p-skeleton>
          <div class="d-flex">
            <p-skeleton width="5rem" height="2rem"></p-skeleton>
            <p-skeleton
              width="5em"
              height="2rem"
              styleClass="mx-2"
            ></p-skeleton>
            <p-skeleton width="5rem" height="2rem"></p-skeleton>
          </div>
        </div>
        <p-skeleton height="4rem" styleClass="my-3"></p-skeleton>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between">
            <p-skeleton
              width="1rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
            <p-skeleton
              width="8rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <div class="mx-1 box-none">
            <p-skeleton
              width="14rem"
              height="14rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center my-2">
          <div class="d-flex justify-content-between">
            <p-skeleton
              width="1rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
            <p-skeleton
              width="8rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <div class="mx-1 box-none">
            <p-skeleton
              width="14rem"
              height="14rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <p-skeleton
            width="30rem"
            height="1.5rem"
            styleClass="mt-4"
          ></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <!-- case 5 for data managment page  END-->

  <!-- case 5 for data managment page this is for MOBILE-VIEW -->
  <div class="container mobile-skeleton" *ngSwitchCase="5">
    <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <p-skeleton height="2rem" styleClass="my-2"></p-skeleton>
        <p-skeleton height="2rem" styleClass="my-2"></p-skeleton>
        <div class="d-flex justify-content-between my-1">
          <p-skeleton width="5rem" height="2rem"></p-skeleton>
          <p-skeleton width="5rem" height="2rem" styleClass="mx-2"></p-skeleton>
          <p-skeleton width="5rem" height="2rem"></p-skeleton>
        </div>
        <div class="d-flex justify-content-center">
          <p-skeleton
            width="10rem"
            height="10rem"
            styleClass="my-3"
          ></p-skeleton>
        </div>
        <div class="d-flex justify-content-center">
          <p-skeleton width="15rem" height="1.5rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <!-- case 5 for data managment page this is for MOBILE-VIEW END-->

  <!-- case 6 for home page -->
  <div class="entity-skeleton-desktop desktop-skeleton" *ngSwitchCase="6">
    <div class="entity-skeleton-wrapper">
      <!-- Header: Search bar + Tab buttons -->
      <div class="entity-skel-header">
        <div class="entity-skel-search">
          <p-skeleton width="100%" height="3rem" borderRadius="50px"></p-skeleton>
        </div>
        <div class="entity-skel-tabs">
          <p-skeleton width="6rem" height="2.5rem" borderRadius="50px"></p-skeleton>
          <p-skeleton width="5rem" height="2.5rem" borderRadius="50px"></p-skeleton>
          <p-skeleton width="5rem" height="2.5rem" borderRadius="50px"></p-skeleton>
          <p-skeleton width="9rem" height="2.5rem" borderRadius="50px"></p-skeleton>
        </div>
      </div>
      <!-- Grid of entity image cards -->
      <div class="entity-skel-grid">
        <div class="entity-skel-card" *ngFor="let item of [1,2,3,4,5,6,7,8,9,10,11,12,13,14]">
          <p-skeleton width="130px" height="130px" borderRadius="17px"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <!-- case 6 for home page END -->

  <!-- case 6 mobile skeleton -->
  <div class="entity-skeleton-mobile mobile-skeleton" *ngSwitchCase="6">
    <div class="entity-skeleton-wrapper">
      <!-- Header: Search bar + Tab buttons stacked -->
      <div class="entity-skel-header-mobile">
        <p-skeleton width="100%" height="2.8rem" borderRadius="50px"></p-skeleton>
        <div class="entity-skel-tabs-mobile">
          <p-skeleton width="5rem" height="2rem" borderRadius="50px"></p-skeleton>
          <p-skeleton width="4rem" height="2rem" borderRadius="50px"></p-skeleton>
          <p-skeleton width="4rem" height="2rem" borderRadius="50px"></p-skeleton>
          <p-skeleton width="7rem" height="2rem" borderRadius="50px"></p-skeleton>
        </div>
      </div>
      <!-- Grid of entity image cards (smaller, 3 columns) -->
      <div class="entity-skel-grid-mobile">
        <div class="entity-skel-card-mobile" *ngFor="let item of [1,2,3,4,5,6,7,8,9]">
          <p-skeleton width="100%" height="0" borderRadius="17px" styleClass="entity-skel-card-ratio"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <!-- case 6 mobile skeleton END -->

  <!-- case 7 skeleton -->
  <div class="container desktop-skeleton" *ngSwitchCase="7">
    <div class="row">
      <div class="col-4 px-5">
        <div class="d-flex justify-content-between my-3">
          <div class="shaddow">
            <p-skeleton width="7rem" height="1.5rem"></p-skeleton>
          </div>
          <div class="d-flex">
            <div class="shaddow-circle mx-1">
              <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
            <div class="shaddow-circle mx-1">
              <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
            <div class="shaddow-circle mx-1">
              <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
            <div class="shaddow-circle mx-1">
              <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="shaddow">
          <p-skeleton height="2rem" styleClass="my-2"></p-skeleton>
        </div>
        <!-- card look ui -->
        <div class="row my-3">
          <div class="col-2">
            <div class="shaddow-rectangle">
              <p-skeleton
                borderRadius="16px"
                shape="rectangle"
                size="2.8rem"
              ></p-skeleton>
            </div>
          </div>
          <div class="col-10">
            <div class="shaddow-profile">
              <p-skeleton
                borderRadius="16px"
                width="100%"
                styleClass="mb-2"
              ></p-skeleton>
            </div>
            <div class="shaddow-profile">
              <p-skeleton borderRadius="16px" width="100%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-2">
            <div class="shaddow-rectangle">
              <p-skeleton
                borderRadius="16px"
                shape="rectangle"
                size="2.8rem"
              ></p-skeleton>
            </div>
          </div>
          <div class="col-10">
            <div class="shaddow-profile">
              <p-skeleton
                borderRadius="16px"
                width="100%"
                styleClass="mb-2"
              ></p-skeleton>
            </div>
            <div class="shaddow-profile">
              <p-skeleton borderRadius="16px" width="100%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-2">
            <div class="shaddow-rectangle">
              <p-skeleton
                borderRadius="16px"
                shape="rectangle"
                size="2.8rem"
              ></p-skeleton>
            </div>
          </div>
          <div class="col-10">
            <div class="shaddow-profile">
              <p-skeleton
                borderRadius="16px"
                width="100%"
                styleClass="mb-2"
              ></p-skeleton>
            </div>
            <div class="shaddow-profile">
              <p-skeleton borderRadius="16px" width="100%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-2">
            <div class="shaddow-rectangle">
              <p-skeleton
                borderRadius="16px"
                shape="rectangle"
                size="2.8rem"
              ></p-skeleton>
            </div>
          </div>
          <div class="col-10">
            <div class="shaddow-profile">
              <p-skeleton
                borderRadius="16px"
                width="100%"
                styleClass="mb-2"
              ></p-skeleton>
            </div>
            <div class="shaddow-profile">
              <p-skeleton borderRadius="16px" width="100%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-2">
            <div class="shaddow-rectangle">
              <p-skeleton
                borderRadius="16px"
                shape="rectangle"
                size="2.8rem"
              ></p-skeleton>
            </div>
          </div>
          <div class="col-10">
            <div class="shaddow-profile">
              <p-skeleton
                borderRadius="16px"
                width="100%"
                styleClass="mb-2"
              ></p-skeleton>
            </div>
            <div class="shaddow-profile">
              <p-skeleton borderRadius="16px" width="100%"></p-skeleton>
            </div>
          </div>
        </div>
        <!-- card look ui END -->
      </div>

      <div class="col-8">
        <div class="width-70 shaddow">
          <p-skeleton height="3rem"></p-skeleton>
        </div>
        <div class="d-flex justify-content-between mt-5">
          <div class="width-25 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
          <div class="width-45 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
          <div class="width-10 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
          <div class="width-25 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
          <div class="width-10 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
          <div class="width-45 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
        </div>
        <div class="width-70 shaddow mt-4">
          <p-skeleton height="1.5rem"></p-skeleton>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="d-flex justify-content-between mt-4">
              <div class="width-25 shaddow w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
              <div class="width-25 shaddow mx-1 w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
              <div class="width-25 shaddow w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
            </div>
          </div>
          <div class="col-4"></div>
          <div class="col-4">
            <div class="d-flex justify-content-between mt-4">
              <div class="width-25 shaddow w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
              <div class="width-25 shaddow mx-1 w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
              <div class="width-25 shaddow w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- case 7 skeleton END -->

  <!-- care 8 -->
  <div class="container" *ngSwitchCase="8">
    <div class="row mx-5 mob-mx-skeleton">
      <div class="col-md-12 col-12 p-0">
        <div class="mx-4">
          <p-skeleton
            width="7rem"
            height="1.5rem"
            styleClass="mb-2"
          ></p-skeleton>
          <p-skeleton
            width="3rem"
            height="1.5rem"
            styleClass="mb-2"
          ></p-skeleton>
          <p-skeleton width="15rem" height="3rem"></p-skeleton>
        </div>

        <div class="border-round border-1 surface-border p-4 surface-card">
          <div class="flex mb-3">
            <div>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
            </div>
          </div>
          <p-skeleton width="100%" height="70px"></p-skeleton>
          <div class="d-flex justify-content-between mt-3">
            <span>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
            </span>
            <span class="d-flex">
              <p-skeleton width="3rem" height="3rem"></p-skeleton>
              <span class="mx-2">
                <p-skeleton width="3rem" height="3rem"></p-skeleton>
              </span>
            </span>
          </div>
        </div>
        <div class="border-round border-1 surface-border p-4 surface-card">
          <div class="flex mb-3">
            <div>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
            </div>
          </div>
          <p-skeleton width="100%" height="70px"></p-skeleton>
          <div class="d-flex justify-content-between mt-3">
            <span>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
            </span>
            <span class="d-flex">
              <p-skeleton width="3rem" height="3rem"></p-skeleton>
              <span class="mx-2">
                <p-skeleton width="3rem" height="3rem"></p-skeleton>
              </span>
            </span>
          </div>
        </div>
        <div class="border-round border-1 surface-border p-4 surface-card">
          <div class="flex mb-3">
            <div>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
            </div>
          </div>
          <p-skeleton width="100%" height="70px"></p-skeleton>
          <div class="d-flex justify-content-between mt-3">
            <span>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
            </span>
            <span class="d-flex">
              <p-skeleton width="3rem" height="3rem"></p-skeleton>
              <span class="mx-2">
                <p-skeleton width="3rem" height="3rem"></p-skeleton>
              </span>
            </span>
          </div>
        </div>
        <div class="border-round border-1 surface-border p-4 surface-card">
          <div class="flex mb-3">
            <div>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
            </div>
          </div>
          <p-skeleton width="100%" height="70px"></p-skeleton>
          <div class="d-flex justify-content-between mt-3">
            <span>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
            </span>
            <span class="d-flex">
              <p-skeleton width="3rem" height="3rem"></p-skeleton>
              <span class="mx-2">
                <p-skeleton width="3rem" height="3rem"></p-skeleton>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- case 8 end -->

  <!-- case 9  -->
  <div *ngSwitchCase="9">
    <div class="row mx-5">
      <div class="col-md-12 col-12 p-0 my-5">
        <div class="container-fluid">
          <p-skeleton width="100%" height="100px"></p-skeleton>
        </div>
      </div>
      <div class="col-md-12 col-12 p-0">
        <div class="card">
          <p-table [value]="tableList" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>.....</th>
                <th>.....</th>
                <th>.....</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
  <!-- case 9 END -->

  <!-- case 10 for data managment page -->
  <div class="container-fluid desktop-skeleton" *ngSwitchCase="10">
    <div class="row d-flex align-items-baseline m-0 v4-bg-view mb-3">
      <!-- 3 inputs -->
      <div class="col-md-4 col-12 my-2"><p-skeleton width="100%" height="3.5rem" borderRadius="8px"></p-skeleton></div>
      <div class="col-md-4 col-12 my-2"><p-skeleton width="100%" height="3.5rem" borderRadius="8px"></p-skeleton></div>
      <div class="col-md-4 col-12 my-2"><p-skeleton width="100%" height="3.5rem" borderRadius="8px"></p-skeleton></div>
      
      <!-- Buttons and Radios -->
      <div class="col-md-12 col-12 my-2">
          <div class="d-flex flex-wrap gap-2">
             <div class="d-flex justify-content-center btn-bg-color p-2"><p-skeleton width="12rem" height="3rem" borderRadius="8px"></p-skeleton></div>
             <div class="d-flex justify-content-center btn-bg-color p-2"><p-skeleton width="20rem" height="3rem" borderRadius="8px"></p-skeleton></div>
          </div>
      </div>
    
      <div class="col-md-12 col-sm-12 col-12">
        <div class="custom-flex-between-column">
          <div class="d-flex flex-wrap gap-2 my-2 w-100">
             <p-skeleton width="7rem" height="3rem" borderRadius="8px" styleClass="my-1 mx-1"></p-skeleton>
             <p-skeleton width="10rem" height="3rem" borderRadius="8px" styleClass="my-1 mx-1"></p-skeleton>
             <p-skeleton width="7rem" height="3rem" borderRadius="8px" styleClass="my-1 mx-1"></p-skeleton>
             <p-skeleton width="7rem" height="3rem" borderRadius="8px" styleClass="my-1 mx-1"></p-skeleton>
             <p-skeleton width="10rem" height="3rem" borderRadius="8px" styleClass="my-1 mx-1"></p-skeleton>
             <p-skeleton width="3rem" height="3rem" borderRadius="8px" styleClass="my-1 mx-1"></p-skeleton>
             <p-skeleton width="9rem" height="3rem" borderRadius="8px" styleClass="my-1 mx-1"></p-skeleton>
             <div class="d-flex flex-wrap m-r-5 ms-auto">
               <p-skeleton width="10rem" height="3rem" borderRadius="8px" styleClass="my-1 mx-1"></p-skeleton>
               <p-skeleton width="8rem" height="3rem" borderRadius="8px" styleClass="my-1 mx-1"></p-skeleton>
             </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="v4-data-flex v4-bg-view py-4 mt-2">
        <div class="v4-w-20" *ngFor="let i of [1,2,3,4,5]">
           <div class="d-flex flex-column align-items-center mb-2">
              <p-skeleton width="50%" height="1rem" styleClass="mb-3"></p-skeleton>
              <div class="v4-data-box d-flex justify-content-center align-items-center w-100">
                 <p-skeleton width="4rem" height="4rem" borderRadius="10px"></p-skeleton>
              </div>
           </div>
        </div>
    </div>
    
    <!-- Data Table -->
    <div class="my-4 mx-3">
        <!-- Header -->
        <div class="d-flex gap-3 mb-3 p-3 bg-light rounded align-items-center">
           <p-skeleton width="2rem" height="2rem"></p-skeleton>
           <p-skeleton width="20%" height="2rem"></p-skeleton>
           <p-skeleton width="70%" height="2rem"></p-skeleton>
        </div>
        <!-- Rows -->
        <div *ngFor="let i of [1, 2, 3, 4]" class="d-flex gap-3 mb-3 p-3 border-bottom align-items-start">
            <p-skeleton width="2rem" height="2rem"></p-skeleton>
            <div class="d-flex align-items-center" style="width: 20%;">
                <p-skeleton width="30px" height="30px" borderRadius="6px" styleClass="me-2"></p-skeleton>
                <p-skeleton width="80%" height="1.5rem"></p-skeleton>
            </div>
            <div class="d-flex flex-column gap-2" style="width: 70%;">
                <!-- Mock field block -->
                <div *ngFor="let j of [1, 2]" class="data-flex w-100 p-2">
                    <div class="d-flex align-items-center mb-2">
                        <p-skeleton width="1rem" height="1rem" shape="circle" styleClass="mx-2"></p-skeleton>
                        <p-skeleton width="30%" height="1rem"></p-skeleton>
                    </div>
                    <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                </div>
            </div>
        </div>
    </div>
  </div>
  <!-- case 10 for data managment page END-->

  <!-- case 10 for data managment page this is for MOBILE-VIEW -->
  <div class="container-fluid mobile-skeleton" *ngSwitchCase="10">
    <div class="row m-0 v4-bg-view mb-3 py-3">
       <div class="col-12 my-2"><p-skeleton width="100%" height="3.5rem" borderRadius="8px"></p-skeleton></div>
       <div class="col-12 my-2"><p-skeleton width="100%" height="3.5rem" borderRadius="8px"></p-skeleton></div>
       <div class="col-12 my-2"><p-skeleton width="100%" height="3.5rem" borderRadius="8px"></p-skeleton></div>
       
       <div class="col-12 my-2">
          <div class="d-flex flex-wrap gap-2 justify-content-between mb-3">
             <p-skeleton width="48%" height="3rem" borderRadius="8px"></p-skeleton>
             <p-skeleton width="48%" height="3rem" borderRadius="8px"></p-skeleton>
          </div>
          <div class="d-flex flex-column gap-3 mt-4">
              <p-skeleton width="100%" height="3rem" borderRadius="8px"></p-skeleton>
              <p-skeleton width="100%" height="3rem" borderRadius="8px"></p-skeleton>
              <p-skeleton width="100%" height="3rem" borderRadius="8px"></p-skeleton>
              <p-skeleton width="100%" height="3rem" borderRadius="8px"></p-skeleton>
          </div>
       </div>
    </div>
    
    <div class="v4-bg-view py-3 mt-2 flex-column px-3 gap-3">
       <div class="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" *ngFor="let i of [1,2,3,4,5]">
           <p-skeleton width="8rem" height="1.5rem"></p-skeleton>
           <p-skeleton width="4.5rem" height="3rem" borderRadius="8px"></p-skeleton>
       </div>
    </div>
    
    <div class="my-4 mx-3">
        <!-- Mobile cards block -->
        <div *ngFor="let i of [1, 2, 3]" class="d-flex flex-column gap-3 mb-4 p-3 border rounded shadow-sm">
            <div class="d-flex align-items-center w-100">
                <p-skeleton width="2rem" height="2rem" styleClass="me-2"></p-skeleton>
                <p-skeleton width="30px" height="30px" borderRadius="6px" styleClass="me-2"></p-skeleton>
                <p-skeleton width="60%" height="1.5rem"></p-skeleton>
            </div>
            <div class="d-flex flex-column gap-2 w-100">
                <div *ngFor="let j of [1, 2]" class="data-flex w-100 p-2 border-top pt-3">
                    <div class="d-flex align-items-center mb-2">
                        <p-skeleton width="1rem" height="1rem" shape="circle" styleClass="mx-2"></p-skeleton>
                        <p-skeleton width="40%" height="1rem"></p-skeleton>
                    </div>
                    <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                </div>
            </div>
        </div>
    </div>
  </div>
  <!-- case 10 for data managment page this is for MOBILE-VIEW END-->

  <div *ngSwitchDefault></div>
</div>
